(function () {
  'use strict';
  if (window.__STNestedAddonLinkerV3) return;
  window.__STNestedAddonLinkerV3 = true;

  const hiddenVariantIds = new Set(["40437224800327","40438730489927","40438732456007","40438732488775","40440562942023","40440562974791","40440564940871","40440570249287","40444188950599","40444456861767","40444456894535","40977064230983","40449244987463","40449245020231","40449245052999","40449245085767","40449249968199","40449250000967","40449250033735","40449250066503","40478001037383","40478001070151","40478001102919","40478001135687","40478028038215","40478028070983","40478028103751","40478028136519","40478699257927","40478699290695","40478699323463","40478699356231","40909491634247","40909491667015","40909491699783","40909491732551","40909491765319","40909497991239","40909498024007","42316392628295","42316392693831","42316392759367","42316392824903","41233306648647","42901759164487","41385878913095","41385886122055","41385886154823","41385886187591","41385886220359","41385887039559","41385887072327","41385887105095","41385887137863","41385968664647","41742587920455","41742587953223","42316390268999","42422908485703","42593249951815","42593250181191","42593250312263","42617922027591","42640220061767","42640220094535","42949758156871","48966096322631","48966097469511","49023574605895","49023574638663","49023574671431","49023574704199","49023574736967","49023574769735"]);
  let lastParentKey = '';
  let lastParentAt = 0;
  const PARENT_TTL = 30000;

  function normalizeId(value) {
    return String(value == null ? '' : value).replace(/^gid:\/\/shopify\/ProductVariant\//, '');
  }

  function isHiddenId(value) {
    return hiddenVariantIds.has(normalizeId(value));
  }

  function isCartAdd(url) {
    try {
      const str = typeof url === 'string' ? url : (url && url.url) || '';
      return /\/cart\/add(?:\.js)?(?:\?|$)/.test(str);
    } catch (e) {
      return false;
    }
  }

  function rowsFromJson(data) {
    if (!data || typeof data !== 'object') return [];
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.items)) return data.items;
    if (data.id != null) return [data];
    return [];
  }

  function rememberParent(payload) {
    const rows = rowsFromJson(payload);
    const parent = rows.find(function(item) {
      const id = item && (item.variant_id || item.id);
      return item && item.key && id && !isHiddenId(id) && !item.parent_relationship;
    });
    if (parent) {
      lastParentKey = String(parent.key);
      lastParentAt = Date.now();
    }
  }

  function rememberedParent() {
    return lastParentKey && (Date.now() - lastParentAt) <= PARENT_TTL ? lastParentKey : '';
  }

  function analyzeJson(data) {
    const rows = rowsFromJson(data);
    return {
      type: 'json',
      data: data,
      rows: rows,
      visible: rows.filter(function(x) { return x && !isHiddenId(x.id); }),
      hidden: rows.filter(function(x) { return x && isHiddenId(x.id); })
    };
  }

  function analyzeParams(params) {
    const rows = [];
    const byIndex = {};
    let flatId = null;

    params.forEach(function(value, key) {
      const match = String(key).match(/^items\[(\d+)\]\[id\]$/);
      if (match) byIndex[match[1]] = { index: match[1], id: value, flat: false };
      if (String(key) === 'id') flatId = value;
    });

    Object.keys(byIndex).forEach(function(k) { rows.push(byIndex[k]); });
    if (!rows.length && flatId != null) rows.push({ index: null, id: flatId, flat: true });

    return {
      type: 'params',
      params: params,
      rows: rows,
      visible: rows.filter(function(x) { return !isHiddenId(x.id); }),
      hidden: rows.filter(function(x) { return isHiddenId(x.id); })
    };
  }

  function cloneParams(body) {
    if (window.FormData && body instanceof FormData) {
      const copy = new FormData();
      body.forEach(function(value, key) { copy.append(key, value); });
      return copy;
    }
    if (window.URLSearchParams && body instanceof URLSearchParams) {
      return new URLSearchParams(body.toString());
    }
    return body;
  }

  function analyzeBody(body) {
    if (!body) return { type:'none', rows:[], visible:[], hidden:[] };

    if (typeof body === 'string') {
      const trimmed = body.trim();
      if (!trimmed) return { type:'none', rows:[], visible:[], hidden:[] };

      if (trimmed[0] === '{' || trimmed[0] === '[') {
        try {
          const result = analyzeJson(JSON.parse(trimmed));
          result.source = 'json-string';
          return result;
        } catch (e) {}
      }

      try {
        const result = analyzeParams(new URLSearchParams(body));
        result.source = 'url-string';
        return result;
      } catch (e) {
        return { type:'none', rows:[], visible:[], hidden:[] };
      }
    }

    if (window.FormData && body instanceof FormData) {
      const result = analyzeParams(cloneParams(body));
      result.source = 'formdata';
      return result;
    }

    if (window.URLSearchParams && body instanceof URLSearchParams) {
      const result = analyzeParams(cloneParams(body));
      result.source = 'urlparams';
      return result;
    }

    return { type:'none', rows:[], visible:[], hidden:[] };
  }

  function serialize(analysis) {
    if (analysis.type === 'json') return JSON.stringify(analysis.data);
    if (analysis.type === 'params') {
      return analysis.source === 'url-string' ? analysis.params.toString() : analysis.params;
    }
    return null;
  }

  function attachSameRequest(analysis) {
    if (!analysis || analysis.visible.length !== 1 || analysis.hidden.length === 0) return false;
    const parentId = analysis.visible[0].id;

    if (analysis.type === 'json') {
      analysis.hidden.forEach(function(item) {
        if (item.parent_id == null && item.parent_line_key == null) item.parent_id = parentId;
      });
      return true;
    }

    if (analysis.type === 'params') {
      analysis.hidden.forEach(function(item) {
        if (item.flat) return;
        const key = 'items[' + item.index + '][parent_id]';
        if (!analysis.params.has(key)) analysis.params.append(key, parentId);
      });
      return true;
    }
    return false;
  }

  function attachExistingParent(analysis, parentKey) {
    if (!analysis || !parentKey || analysis.visible.length !== 0 || analysis.hidden.length === 0) return false;

    if (analysis.type === 'json') {
      analysis.hidden.forEach(function(item) {
        if (item.parent_id == null && item.parent_line_key == null) item.parent_line_key = parentKey;
      });
      return true;
    }

    if (analysis.type === 'params') {
      analysis.hidden.forEach(function(item) {
        if (item.flat) {
          if (!analysis.params.has('parent_line_key')) {
            analysis.params.append('parent_line_key', parentKey);
          }
        } else {
          const key = 'items[' + item.index + '][parent_line_key]';
          if (!analysis.params.has(key)) analysis.params.append(key, parentKey);
        }
      });
      return true;
    }
    return false;
  }

  const nativeFetch = window.fetch;

  async function fetchNewestVisibleParent() {
    const known = rememberedParent();
    if (known) return known;
    if (typeof nativeFetch !== 'function') return '';

    try {
      const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      const response = await nativeFetch(root + 'cart.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      });
      const cart = await response.json();
      const parent = (cart.items || []).find(function(item) {
        const id = item && (item.variant_id || item.id);
        return item && item.key && id && !isHiddenId(id) && !item.parent_relationship;
      });
      if (parent) {
        lastParentKey = String(parent.key);
        lastParentAt = Date.now();
        return lastParentKey;
      }
    } catch (e) {}
    return '';
  }

  async function waitForParentKey() {
    const immediate = rememberedParent();
    if (immediate) return immediate;

    for (let i = 0; i < 20; i++) {
      await new Promise(function(resolve) { setTimeout(resolve, 100); });
      const key = rememberedParent();
      if (key) return key;
    }

    return fetchNewestVisibleParent();
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = async function(input, init) {
      if (!isCartAdd(input) || !init || String(init.method || 'GET').toUpperCase() !== 'POST' || !init.body) {
        return nativeFetch.apply(this, arguments);
      }

      const analysis = analyzeBody(init.body);
      const nextInit = Object.assign({}, init);

      if (analysis.visible.length === 1 && analysis.hidden.length > 0) {
        attachSameRequest(analysis);
        const body = serialize(analysis);
        if (body != null) nextInit.body = body;
      } else if (analysis.visible.length === 0 && analysis.hidden.length > 0) {
        const parentKey = await waitForParentKey();
        if (parentKey) {
          attachExistingParent(analysis, parentKey);
          const body = serialize(analysis);
          if (body != null) nextInit.body = body;
        }
      }

      const response = await nativeFetch.call(this, input, nextInit);

      if (analysis.visible.length > 0) {
        try {
          rememberParent(await response.clone().json());
        } catch (e) {}
      }

      return response;
    };
  }

  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open && XMLHttpRequest.prototype.send) {
    const nativeOpen = XMLHttpRequest.prototype.open;
    const nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url) {
      this.__stCartAdd = String(method || '').toUpperCase() === 'POST' && isCartAdd(url);
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(body) {
      if (!this.__stCartAdd || !body) return nativeSend.call(this, body);

      const xhr = this;
      const analysis = analyzeBody(body);

      function sendNow(nextBody) {
        if (analysis.visible.length > 0) {
          xhr.addEventListener('loadend', function() {
            try {
              const payload = typeof xhr.response === 'object' && xhr.response
                ? xhr.response
                : JSON.parse(xhr.responseText || '{}');
              rememberParent(payload);
            } catch (e) {}
          }, { once: true });
        }
        return nativeSend.call(xhr, nextBody);
      }

      if (analysis.visible.length === 1 && analysis.hidden.length > 0) {
        attachSameRequest(analysis);
        const nextBody = serialize(analysis);
        return sendNow(nextBody != null ? nextBody : body);
      }

      if (analysis.visible.length === 0 && analysis.hidden.length > 0) {
        waitForParentKey().then(function(parentKey) {
          if (parentKey) attachExistingParent(analysis, parentKey);
          const nextBody = serialize(analysis);
          sendNow(nextBody != null ? nextBody : body);
        }).catch(function() {
          sendNow(body);
        });
        return;
      }

      return sendNow(body);
    };
  }
})();